export default __webpack_public_path__ + "static/media/1 year.b86371a6.jpg";